import React from 'react';
import { motion } from 'framer-motion';
import personalPhoto from '../../assets/images/my-photo.jpg';
import '../../assets/styles/AboutSection.css';

const AboutSection = () => (
  <motion.section
    className="about-section section"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: 'easeOut' }}
    viewport={{ once: true, amount: 0.1 }}
  >
    <div className="section-inner two-col">
      <motion.div
        className="about-image"
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.15 }}
        viewport={{ once: true, amount: 0.1 }}
      >
        <img src={personalPhoto} alt="Ajani Anderson" />
      </motion.div>

      <motion.div
        className="about-content"
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.25 }}
        viewport={{ once: true, amount: 0.1 }}
      >
        <p className="eyebrow">About</p>
        <h2>Meet your designer</h2>
        <p className="body-lora">
          Hi, I'm <strong>Ajani Anderson</strong>, the creative mind behind{' '}
          <strong>Next Level Websites</strong>. I specialize in crafting professional,
          modern websites designed to help small businesses grow and thrive in the digital world.
        </p>
        <p className="body-lora">
          With a strong focus on user experience, branding, and functionality, I work closely
          with my clients to ensure their websites align with their goals and resonate with
          their audience.
        </p>
        <a href="/about" className="btn-primary-warm">Learn more</a>
      </motion.div>
    </div>
  </motion.section>
);

export default AboutSection;
